<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_556')}}</div>
    <div slot="body">
      <a-alert class="mb-2" :message="$t('scope.text_557')" banner />
      <template v-if="step === 1">
        <p>{{$t('scope.text_558')}}</p>
        <img class="stepImg" :src="stepImage" />
        <img class="stepImg" :src="chooseProject" />
      </template>
      <template v-if="step === 2">
        <p>{{$t('scope.text_559')}}</p>
        <img class="stepImg" :src="stepImage" />
        <img class="stepImg" :src="addMember" />
      </template>
      <template v-if="step === 3">
        <p>{{$t('scope.text_560')}}</p>
        <img class="stepImg" :src="stepImage" />
      </template>
      <template v-if="step === 4">
        <p>{{$t('scope.text_561')}}</p>
        <a-form
          class="mt-3"
          :form="form.fc">
          <a-form-item
            :label="$t('scope.text_562')"
            v-bind="formItemLayout">
            <a-input v-decorator="decorators.project_id" />
          </a-form-item>
        </a-form>
        <img class="stepImg" :src="stepImage" />
      </template>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="next" v-if="step < 4">{{$t('scope.text_563')}}</a-button>
      <a-button type="primary" @click="handleConfirm" :loading="loading" v-if="step === 4">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'BindGoogleProjectDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      step: 1,
      chooseProject: require('../assests/images/chooseProject.png'),
      addMember: require('../assests/images/addMember.png'),
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        project_id: [
          'project_id',
          {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: this.$t('scope.text_564') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: { span: 20 },
        labelCol: { span: 3 },
      },
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
    }),
    stepImage () {
      return require(`../assests/images/step${this.step || 1}.png`)
    },
  },
  created () {
    this.form.fc.getFieldDecorator('project_id', {
      preserve: true,
    })
  },
  methods: {
    next () {
      this.step++
    },
    doOpen (data) {
      return new this.$Manager('cloudsupplier_customers').create({ data })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const data = {
          customer_id: this.customer.id,
          provider: this.params.data[0].cloudsupplier,
          project_id: values.project_id,
        }
        await this.doOpen(data)
        this.loading = false
        this.$message.success(this.$t('scope.text_565'))
        this.cancelDialog()
        this.params.refresh()
      } catch (error) {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.stepImg {
  width: 400px;
}
</style>
